import { useEffect, useState } from 'react';
import { Linkedin, Mail, Twitter } from 'lucide-react';

const socialLinks = [
  {
    name: 'LinkedIn',
    href: 'https://www.linkedin.com/in/enzo-chevallier-6a69b77b/',
    icon: Linkedin,
  },
  {
    name: 'X',
    href: 'https://x.com/EnzoChevallier',
    icon: Twitter,
  },
  {
    name: 'Email',
    href: 'mailto:contact@virtuoz-solutions.com',
    icon: Mail,
  },
];

const SocialLinks = () => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setMounted(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="mb-20">
      <div className="flex items-center gap-6">
        {socialLinks.map((link, index) => {
          const Icon = link.icon;
          return (
            <a
              key={link.name}
              href={link.href}
              target={link.href.startsWith('mailto') ? undefined : '_blank'}
              rel={link.href.startsWith('mailto') ? undefined : 'noopener noreferrer'}
              className={`group flex items-center gap-2 text-sm text-muted hover:text-primary transition-all duration-500 ease-out-expo ${
                mounted ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <span className="relative">
                <Icon className="w-4 h-4 transition-transform duration-300 group-hover:scale-110" />
                {/* Glow effect on hover */}
                <span className="absolute inset-0 bg-primary/30 blur-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </span>
              <span className="font-heading tracking-wide relative">
                {link.name}
                {/* Underline effect */}
                <span className="absolute -bottom-0.5 left-0 w-0 h-px bg-primary transition-all duration-300 group-hover:w-full" />
              </span>
            </a>
          );
        })}

        {/* Decorative separator */}
        <span className="flex-1 h-px bg-gradient-to-r from-foreground/5 to-transparent" />
      </div>
    </section>
  );
};

export default SocialLinks;
